module.exports = __webpack_public_path__ + "img/industry_solution3.71c82a4d.png";